import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import CreditNoteDetailsPageActionButton from '../components/CreditNoteDetailsPageActionButton';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import CreditNoteForm from '../components/CreditNoteForm';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import PeppolResponseStatusCard from '../../common/PeppolResponseStatusCard';
import { useGetCreditNoteHandler } from '../dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function CreditNoteDetailsPage() {
  useDocumentTitle('Credit Note Details');
  const { document_id } = useParams();
  const { creditNote, isLoading } = useGetCreditNoteHandler(document_id);
  if (isLoading || !creditNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {creditNote && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Credit Note Details" identifier={creditNote?.document_id}>
            <CreditNoteDetailsPageActionButton data={creditNote} />
          </TopBar>
        </Box>
      )}
      <IrbmStatusCard document={creditNote} />
      <PeppolResponseStatusCard document={creditNote} />

      <CreditNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={creditNote} readOnly={true} />
    </Stack>
  );
}
